import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.string,
  title: PropTypes.string,
  tierTitle: PropTypes.string,
  address: PropTypes.shape({
    city: PropTypes.string,
    state: PropTypes.string,
    country: PropTypes.string,
  }),
  status: PropTypes.string,
});
